<template>
  <el-table-column
    prop="user.last_name"
    sortable="custom"
    label="Képviselő"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <span>{{ scope.row.driver.last_name }} {{ scope.row.driver.first_name }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'user.last_name',
  };
</script>
